/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Logo_AltInputs */



/**
* | output |
* | --- |
* | "Iconik logo" |
*
* @param {Iconik_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_logo_alt = /** @type {((inputs?: Iconik_Logo_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Logo_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Logo Iconik")
	if (locale === "de") return /** @type {LocalizedString} */ ("Iconik-Logo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Logo iconico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Логотип Iconik")
	if (locale === "es") return /** @type {LocalizedString} */ ("Logotipo de Iconik")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Iconik 标志")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Iconikロゴ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आइकॉनिक लोगो")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Logotipo Iconik")
	return /** @type {LocalizedString} */ ("Iconik logo")
});